import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { sharedShiftService } from 'api/services';
import { Site } from 'shared/hooks';
import { PreferredWorkerProposalsRequestDto } from 'api/services/shift/dto/preferred-worker-proposals.dto';

export const useGetPreferredWorkerProposals = (
  site: Site,
  params: PreferredWorkerProposalsRequestDto,
  enabled: boolean = false
) => {
  return useQuery({
    queryKey: QUERY_KEYS.preferredWorkerProposalsWithFilters(params),
    queryFn: async ({ pageParam = 0 }) =>
      await sharedShiftService.getPreferredWorkerProposals(site, {
        page: params.page ?? pageParam,
        fromDate: params.fromDate,
        pageSize: params.pageSize,
        company: params.company,
        branchOffices: params.branchOffices,
        departments: params.departments,
        jobType: params.jobType,
        filledStatus: params.filledStatus,
        workerId: params.workerId,
        isFreelance: params.isFreelance,
        isTempWork: params.isTempWork,
      }),
    getNextPageParam: (lastGroup) => lastGroup.nextPage,
    enabled,
  });
};
